float uvDirection = (uv.x - 0.5);
float ste = step(0.99, vColor.r);
float bendPos = uBendUv;
float normalLerp = smoothstep(bendPos - uBendLength, bendPos + uBendLength, 1. - uv.y);
ste *= uvDirection;
ste *= smoothstep(bendPos - uBendLength, bendPos + uBendLength, 1. - uv.y);
float ste2 = ste * uBendValue;
transformed += vec3(0., 0., ste2);
// vec4 targetNormal = modelMatrix * vec4(0., 0., 1., 0.);
vNormal = mix(vNormal, uTargetNormal, vColor.g * normalLerp);
vNormal = vNormal;
#include <project_vertex>